/* eslint-disable react/no-unknown-property */
import React from 'react';
import { IconsPropsType } from './icons.config.type';
import tinycolor from 'tinycolor2';

const DecisiveCondition: React.FC<IconsPropsType> = ({ style, color, onClick, className, numberText }) => {
  const fontSize = (numberText?.length ?? 0) <= 6 ? 12 : (numberText?.length ?? 0) <= 9 ? 10 : 8;

  return (
    <svg
      style={{ ...style }}
      width="200"
      height="200"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path d="M50 5L95 90H5L50 5Z" stroke="black" strokeWidth="3" fill={color} />
      {numberText && (
        <text
          x="50%"
          y="70%"
          textAnchor="middle"
          fontSize={fontSize}
          fontWeight="bold"
          fill={tinycolor(color).isLight() ? 'black' : 'white'}
        >
          {numberText}
        </text>
      )}
    </svg>
  );
};

DecisiveCondition.defaultProps = {
  style: { width: '80px', height: '80px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
  numberText: undefined,
};

export default DecisiveCondition;
